import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <p>Digitalización Web creada por <a href="https://sec-hat.com" target="_blank" rel="noopener noreferrer">sec-hat.com</a></p>
    </footer>
  );
};

export default Footer;
